import React from 'react'
import Heading from '../../components/Heading'

const PPCMarketing = () => {
  return (
    <div className="mx-[6%] py-[4%]">
      <span className="text-center ">
        <Heading content="How Does PPC Marketing Work?" />
      </span>
      <div className="flex justify-around flex-wrap my-[3%]">
        <img src="/Images/ppc.svg" alt="" className="w-[550px] h-[280px]" />

        <div className="lg:w-[50%] text-left">
          <p className="leading-[30px] text-[18px] tracking-normal mb-[10px]">
            PPC advertising is a keyword-driven marketing strategy where the
            value of different search terms and phrases is determined by factors
            such as their search volume, difficulty, and competition level. PPC
            campaign management services like AdWords evaluate these factors to
            assign a value to keywords. As the number of advertisers competing
            for the same keyword increases, so does the keyword price.
          </p>
          <p className="leading-[30px] text-[18px] tracking-normal">
            Marketing platforms, like Google's homepage, have a finite number of
            slots available for Google pay per click advertising. This means
            that advertisers must compete for these limited slots to secure
            their PPC spot. It's not possible to merely pay more to enhance the
            visibility of your Google PPC ads.
          </p>
        </div>
      </div>
      <div>
        <p className="leading-[30px] text-[18px] text-left tracking-normal mb-[10px]">
          Ad auction is an automated process employed by search engines to
          assess the relevance and credibility of ads displayed on their SERPs,
          including Google pay per click and other PPC ads. In order to enhance
          your ad placement and reduce cost per click (CPC), it is crucial to
          maintain a high Quality Score for your Google pay per click ads.
        </p>
        <p className="leading-[30px] text-[18px] text-left tracking-normal mb-[10px]">
          Creating a relevant and valuable pay-per-click ad campaign for your
          target audience, incorporating relevant keywords, achieving high
          click-through rates (CTRs), and directing prospects to an
          SEO-optimized landing page are some essential steps to ensure a good
          Quality Score for your PPC ads.
        </p>
        <p className="leading-[30px] text-[18px] text-left tracking-normal mb-[10px]">
          If you're pressed for time to conduct a PPC audit and initiate a pay
          per click campaign, you can rely on our pay per click management
          company to handle the technical aspects for you.
        </p>
      </div>
      <div>
        <span className="text-center mx-[3%]">
          <Heading content="We Help You Improve Your Quality Score and Generate More Online Revenue" />
        </span>

        <div className='md:flex justify-between'>
          <div className='md:w-7/12 px-1 mt-[3%]'>
            <p className="leading-[30px] text-left text-[18px] tracking-normal mb-[10px]">
              Thrive Internet Marketing Agency helps you achieve your SEM goals
              by understanding your business, identifying key metrics, and
              structuring your PPC campaign to drive traffic and reduce
              expenses. Our expert team develops customized strategies to
              maximize your ROI and bring new visitors to your website.
            </p>
            <p className="leading-[30px] text-left text-[18px] tracking-normal mb-[10px]">
              Our PPC management team is here to help you make the most of your
              advertising budget by strategically targeting your ideal audience
              and maximizing your ROI. With our customized approach and expert
              knowledge of PPC advertising, we can help your business drive more
              traffic and increase conversions.
            </p>
          </div>
          <div className='md:w-1/3'>
            <img src="/Images/improvequality.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PPCMarketing